export default (function (_ref) {
  var id = _ref.id,
      required = _ref.required,
      label = _ref.label,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? '' : _ref$classes;
  return label ? /*#__PURE__*/React.createElement("label", {
    className: "".concat(classes, " ").concat(required ? 'cb-required' : ''),
    htmlFor: id
  }, label) : null;
});